import { useState } from 'react';

import { Emoji } from '../types';

const EMOJI_VISIBILITY_TIMEOUT = 3000;

let enemyEmojiTimerId: NodeJS.Timeout;
let playerEmojiTimerId: NodeJS.Timeout;

const useEmojis = () => {
  const [isEnemyMuted, setIsEnemyMuted] = useState<boolean>(false);
  const [enemyEmoji, setEnemyEmoji] = useState<Emoji>();
  const [playerEmoji, setPlayerEmoji] = useState<Emoji>();

  const toggleEnemyEmoji = () => setIsEnemyMuted(!isEnemyMuted);

  const showEnemyEmoji = (emoji: Emoji) => {
    clearTimeout(enemyEmojiTimerId);
    setEnemyEmoji(emoji);
    enemyEmojiTimerId = setTimeout(() => setEnemyEmoji(undefined), EMOJI_VISIBILITY_TIMEOUT);
  };

  const showPlayerEmoji = (emoji: Emoji) => {
    clearTimeout(playerEmojiTimerId);
    setPlayerEmoji(emoji);
    playerEmojiTimerId = setTimeout(() => setPlayerEmoji(undefined), EMOJI_VISIBILITY_TIMEOUT);
  };

  return { toggleEnemyEmoji, showEnemyEmoji, showPlayerEmoji, enemyEmoji, playerEmoji, isEnemyMuted };
};

export default useEmojis;
